import { CMaterialEventType } from '../types/material';

export const DEFAULT_EVENT_LIST: CMaterialEventType[] = [
  {
    event: 'onClick',
  },
  {
    event: 'onDoubleClick',
  },
  {
    event: 'onMouseOver',
  },
  {
    event: 'onMouseDown',
  },
  {
    event: 'onMouseUp',
  },
  {
    event: 'onMouseMove',
  },
  {
    event: 'onMouseIn',
  },
  {
    event: 'onMouseOut',
  },
  {
    event: 'onMouseLeave',
  },
];
